class LinkTypeChoiceController {
  constructor(LinkTypeService, AlertService, RacedaysService) {
    this.LinkTypeService = LinkTypeService;
    this.AlertService = AlertService;
    this.RacedaysService = RacedaysService;
  }

  $onInit() {
    var self = this;
    self.options = [{ label: 'None', value: '' }];
    self.mainNavOptions = [
      { id: 'whats_on', name: 'Whats On' },
      { id: 'map', name: 'Map' },
      { id: 'video', name: 'Video' },
      { id: 'transport', name: 'Transport' },
      { id: 'planner', name: 'Planner' }
    ];
    for (var i = 0; i < self.linkTypes.length; i++) {
      var displayName = self.linkTypes[i].name;
      // Remove snake case
      displayName = displayName.replace(/_/g, ' ');
      // Capitalize first letter
      displayName =
        displayName.charAt(0).toUpperCase() +
        displayName.substr(1).toLowerCase();

      self.options.push({
        label: displayName,
        value: self.linkTypes[i].id
      });
    }
    // default to none
    self.advert.linkType = '';
    if (self.linkValues) {
      if (self.linkValues.external) {
        angular.forEach(self.linkTypes, function(linkType) {
          if (linkType.name === 'external') {
            self.advert.linkType = linkType.id;
            self.selected = 'external';
          }
        });
      }
      if (self.linkValues.raceday) {
        angular.forEach(self.linkTypes, function(linkType) {
          if (linkType.name === 'raceday') {
            self.advert.linkType = linkType.id;
            self.selected = 'raceday';

            angular.forEach(self.racedays, function(raceday) {
              if (parseInt(raceday.id) === parseInt(self.advert.linkValue)) {
                self.linkValues.raceday = raceday.id;
              }
            });
          }
        });
      }
      if (self.linkValues.internal) {
        angular.forEach(self.linkTypes, function(linkType) {
          if (linkType.name === 'internal') {
            self.advert.linkType = linkType.id;
            self.selected = 'internal';

            angular.forEach(self.mainNavOptions, function(navItem) {
              if (navItem.id === self.advert.linkValue) {
                self.linkValues.internal = navItem;
              }
            });
          }
        });
      }
      if (self.linkValues.location) {
        angular.forEach(self.linkTypes, function(linkType) {
          if (linkType.name === 'location') {
            self.advert.linkType = linkType.id;
            self.selected = 'location';

            angular.forEach(self.locations, function(location) {
              if (parseInt(location.id) === parseInt(self.advert.linkValue)) {
                self.linkValues.location = location.id;
              }
            });
          }
        });
      }
      if (self.linkValues.non_racing_event) {
        angular.forEach(self.linkTypes, function(linkType) {
          if (linkType.name === 'non_racing_event') {
            self.advert.linkType = linkType.id;
            self.selected = 'non_racing_event';
            angular.forEach(self.nonRacingEvents, function(non_racing_event) {
              if (
                parseInt(non_racing_event.id) ===
                parseInt(self.advert.linkValue)
              ) {
                self.linkValues.non_racing_event = non_racing_event.id;
              }
            });
          }
        });
      }
    }

    if (!self.linkValues) {
      self.linkValues = {};
      if (self.racedays !== undefined) {
        self.linkValues.raceday = self.racedays[0].id;
      } else {
        // TODO Empty object
      }
      self.linkValues.internal = self.mainNavOptions[0].id;
      if (self.locations !== undefined) {
        self.linkValues.location = self.locations[0].id;
        // TODO Modify this once we properly send through non_racevents
        self.linkValues.non_racing_event = self.locations[0].id;
      }
    }
  }

  changed() {
    var self = this;
    self.selected = 'None';
    self.advert.linkValue = null;
    angular.forEach(self.linkTypes, link => {
      if (link.id === this.advert.linkType) {
        self.selected = link.name;
      }
    });
  }
}
LinkTypeChoiceController.$inject = [
  'LinkTypeService',
  'AlertService',
  'RacedaysService'
];
export default LinkTypeChoiceController;
